export default __webpack_public_path__ + "static/media/vines.7d7e0915.png";